"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContainerFreightStationApiErrorCode = void 0;
exports.ContainerFreightStationApiErrorCode = {
    RELATED_MODEL_DOES_NOT_EXIST: 'RELATED_MODEL_DOES_NOT_EXIST'
};
//# sourceMappingURL=container-freight-station-api-error-code.js.map